/**
 * Central Social Media Configuration for Cameroon Land Market
 * 
 * Only active, verified profile URLs should be configured here.
 * Empty strings will automatically hide the corresponding social link
 * across the site, preventing dead links or fallback to generic homepages.
 */
export interface SocialLinksConfig {
  facebook: string;
  instagram: string;
  linkedin: string;
  youtube: string;
}

export const socialLinks: SocialLinksConfig = {
  facebook: '',
  instagram: '',
  linkedin: '',
  youtube: '',
};

export interface ActiveSocialLink {
  key: keyof SocialLinksConfig;
  url: string;
  labelEn: string;
  labelFr: string;
}

export function getActiveSocialLinks(): ActiveSocialLink[] {
  const meta: Record<keyof SocialLinksConfig, { labelEn: string; labelFr: string }> = {
    facebook: {
      labelEn: 'Cameroon Land Market on Facebook',
      labelFr: 'Cameroon Land Market sur Facebook',
    },
    instagram: {
      labelEn: 'Cameroon Land Market on Instagram',
      labelFr: 'Cameroon Land Market sur Instagram',
    },
    linkedin: {
      labelEn: 'Cameroon Land Market on LinkedIn',
      labelFr: 'Cameroon Land Market sur LinkedIn',
    },
    youtube: {
      labelEn: 'Cameroon Land Market on YouTube',
      labelFr: 'Cameroon Land Market sur YouTube',
    },
  };

  const active: ActiveSocialLink[] = [];
  for (const [key, rawUrl] of Object.entries(socialLinks)) {
    const trimmed = (rawUrl || '').trim();
    // Only consider valid URLs that are not '#' or generic homepages
    if (trimmed && trimmed !== '#' && !/^https?:\/\/(www\.)?(facebook|instagram|linkedin|youtube)\.com\/?$/i.test(trimmed)) {
      const k = key as keyof SocialLinksConfig;
      active.push({
        key: k,
        url: trimmed,
        labelEn: meta[k].labelEn,
        labelFr: meta[k].labelFr,
      });
    }
  }

  return active;
}
